var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 338,
    viewBox: "0 0 600 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M600 0H0V337.5H600V0Z",
    fill: "#08BC80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M203 289.8C210.953 289.8 217.4 283.353 217.4 275.4C217.4 267.447 210.953 261 203 261C195.047 261 188.6 267.447 188.6 275.4C188.6 283.353 195.047 289.8 203 289.8Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.8 290.2C298.753 290.2 305.2 283.753 305.2 275.8C305.2 267.847 298.753 261.4 290.8 261.4C282.847 261.4 276.4 267.847 276.4 275.8C276.4 283.753 282.847 290.2 290.8 290.2Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.8 182.2C298.753 182.2 305.2 175.753 305.2 167.8C305.2 159.847 298.753 153.4 290.8 153.4C282.847 153.4 276.4 159.847 276.4 167.8C276.4 175.753 282.847 182.2 290.8 182.2Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M378.6 290.2C386.553 290.2 393 283.753 393 275.8C393 267.847 386.553 261.4 378.6 261.4C370.647 261.4 364.2 267.847 364.2 275.8C364.2 283.753 370.647 290.2 378.6 290.2Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M378.6 182.2C386.553 182.2 393 175.753 393 167.8C393 159.847 386.553 153.4 378.6 153.4C370.647 153.4 364.2 159.847 364.2 167.8C364.2 175.753 370.647 182.2 378.6 182.2Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M378.6 94.1C386.553 94.1 393 87.6529 393 79.7C393 71.7471 386.553 65.3 378.6 65.3C370.647 65.3 364.2 71.7471 364.2 79.7C364.2 87.6529 370.647 94.1 378.6 94.1Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 272.8C210.953 272.8 217.4 266.353 217.4 258.4C217.4 250.447 210.953 244 203 244C195.047 244 188.6 250.447 188.6 258.4C188.6 266.353 195.047 272.8 203 272.8Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8 273.2C298.753 273.2 305.2 266.753 305.2 258.8C305.2 250.847 298.753 244.4 290.8 244.4C282.847 244.4 276.4 250.847 276.4 258.8C276.4 266.753 282.847 273.2 290.8 273.2Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8 165.2C298.753 165.2 305.2 158.753 305.2 150.8C305.2 142.847 298.753 136.4 290.8 136.4C282.847 136.4 276.4 142.847 276.4 150.8C276.4 158.753 282.847 165.2 290.8 165.2Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6 273.2C386.553 273.2 393 266.753 393 258.8C393 250.847 386.553 244.4 378.6 244.4C370.647 244.4 364.2 250.847 364.2 258.8C364.2 266.753 370.647 273.2 378.6 273.2Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6 165.2C386.553 165.2 393 158.753 393 150.8C393 142.847 386.553 136.4 378.6 136.4C370.647 136.4 364.2 142.847 364.2 150.8C364.2 158.753 370.647 165.2 378.6 165.2Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6 77.1C386.553 77.1 393 70.653 393 62.7001C393 54.7471 386.553 48.3 378.6 48.3C370.647 48.3 364.2 54.7471 364.2 62.7001C364.2 70.653 370.647 77.1 378.6 77.1Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 61.5H364.2V151.3H393V61.5Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393 170.3H364.2V260.1H393V170.3Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.3 170.3H276.5V260.1H305.3V170.3Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 378.63,
    y1: 151.298,
    x2: 378.63,
    y2: 61.5445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 378.63,
    y1: 260.065,
    x2: 378.63,
    y2: 170.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 290.849,
    y1: 260.065,
    x2: 290.849,
    y2: 170.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 337.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card-2.55f4e31609d7de357a7f10746f0fce45.svg";
export { ForwardRef as ReactComponent };